import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_5 = { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "row mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_29 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_30 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_31 = {
  key: 2,
  class: "badge text-outline-info"
}
const _hoisted_32 = {
  key: 3,
  class: "badge text-outline-info"
}
const _hoisted_33 = {
  key: 4,
  class: "badge text-outline-info"
}
const _hoisted_34 = {
  key: 5,
  class: "badge text-outline-info"
}
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_36 = { class: "dropdown" }
const _hoisted_37 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_41 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "fw-bold" }
const _hoisted_47 = { class: "mt-15 mt-md-0" }
const _hoisted_48 = { class: "pagination mb-0" }
const _hoisted_49 = {
  key: 0,
  class: "page-item"
}
const _hoisted_50 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "page-item"
}
const _hoisted_53 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true",
  style: {"z-index":"9999"}
}
const _hoisted_54 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-header" }
const _hoisted_57 = { class: "modal-title fs-5" }
const _hoisted_58 = { class: "modal-body" }
const _hoisted_59 = { style: {} }
const _hoisted_60 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_61 = {
  key: 1,
  class: "text-success fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_64 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_65 = { class: "modal-footer" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_68 = { style: {"color":"#FFF"} }
const _hoisted_69 = {
  class: "modal fade",
  id: "filterLeadModal1",
  tabindex: "-1",
  "aria-hidden": "true",
  style: {"z-index":"9999"}
}
const _hoisted_70 = { class: "modal-dialog modal-md modal-dialog-centered" }
const _hoisted_71 = { class: "modal-content" }
const _hoisted_72 = { class: "modal-header" }
const _hoisted_73 = { class: "modal-title fs-5" }
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = { style: {} }
const _hoisted_76 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_77 = {
  key: 1,
  class: "text-success fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_80 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_81 = {
  key: 1,
  class: "table-responsive",
  style: {"margin-top":"1%"}
}
const _hoisted_82 = {
  id: "",
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_83 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_84 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_85 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_86 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_87 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_88 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_89 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_90 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_91 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_92 = { class: "modal-footer" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_95 = { style: {"color":"#FFF"} }

import {ref, onMounted,onBeforeMount,inject  } from "vue";
import { useRoute} from 'vue-router'
import axios from 'axios';
import flatpickr from "flatpickr";
import { useI18n } from "vue-i18n";
import html2pdf from "html2pdf.js";
import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import {current_permissions} from '../../../utils/permission';
import{showToast,checkSessionValidate} from '../../../utils/function'
import { useTableFilter } from "../../../utils/UseTablefilter";
declare interface Transaction {
    id: number,
    payoutId: string,
    clientId: string,
    operator: string,
    contact: string,
    amount: string,    
    transactionDate: string,
    paymentStatus: string,
    payoutType:number,
    validationStatus:string,
    bulkTotalAmount:string,
    intBulkId:string
}

declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
}

declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
}
const leadPlaceholder = "Select date";

export default /*@__PURE__*/_defineComponent({
  __name: 'PendingTransfertContent',
  setup(__props) {


const backApi=inject('back');
let role: string|null = localStorage.getItem('role');

let url = '';
  if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
    url = backApi + '/secure/transactions/extended';
  } else {
    url = backApi + '/secure/transactions';
  }



const { t } = useI18n();
let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref(''); 
const status = ref(''); 
const message = ref(''); 
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');
let type_of_task = 'default'
    
const transactions =ref(new Array<Transaction>());
const transaction1s =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);

let transactionId:string|null;
let idType:string|null;

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function paymentStatusLabelOf(pStatus: string) {
  if (pStatus === 'SUCCEEDED') return t('validation.success');
  if (pStatus === 'FAILED') return t('validation.failed');
  if (pStatus === 'PROCESSING') return t('validation.processing');
  if (pStatus === 'PENDING') return t('validation.pending');
  if (pStatus === 'INITIATED') return t('validation.initiated');
  if (pStatus === 'SCHEDULED') return t('validation.scheduled');
  return '';
}

// Montant affiché : toujours le montant individuel de la transaction.
// On n'utilise plus bulkTotalAmount puisque les transactions ne sont
// plus regroupées/cumulées par lot : chaque ligne = une transaction.
function displayedAmountOf(tr: Transaction) {
  return tr.amount;
}

const {
  searchQuery,
  paginatedData: paginatedTransactions,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  transactions,
  [
    (tr: Transaction) => tr.payoutId,
    (tr: Transaction) => tr.clientId,
    (tr: Transaction) => tr.operator?.mnoName,
    (tr: Transaction) => tr.contact,
    (tr: Transaction) => displayedAmountOf(tr),
    (tr: Transaction) => tr.transactionDate ? formatDateFr(new Date(tr.transactionDate)) : '',
    (tr: Transaction) => paymentStatusLabelOf(tr.paymentStatus),
  ],
  15
);

const cancel = () =>{
  status.value="";
  errorId.value="";
  errors.value="";
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  // // selectedStatus.value = event.target.value;
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}
    

onMounted(() => {
  checkSessionValidate(1)
 // loader.value=false; 
//  alert(window.history.back())

const route = useRoute();
transactionId = route.params.transactionId;  
idType = route.params.idType; 
if(transactionId!='default'){
  type_of_task = 'individual'
} 
// alert(transactionId);
// alert(idType);

  getTransactions();
 
  setTimeout(function () {
    //loader.value=true; 
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

 

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

});
const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transaction.value = response.data;  //.data.users   
        // data  = response.data.transactions;  
        operator.value=  response.data.operator.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else if(response.data.paymentStatus==='PENDING'){
          paymentStatus.value = "EN ATTENTE"
         }else if(response.data.paymentStatus==='INITIATED'){
          paymentStatus.value = "INITIÉ"
         }else if(response.data.paymentStatus==='SCHEDULED'){
          paymentStatus.value = "PLANIFIÉ"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}

const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    if(type_of_task!='default'){
      let param = `${idType}=${transactionId}`;
      axios.get(`${url}?${param}`,{
          headers: {
              Authorization: `Bearer ${token}`
          }
      })
      .then((response) => {
          transactions.value = response.data.data;
          loader.value=true;
      }).catch((error) => {
          loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }
          }
      });
      return;
    }

    const paramInitiated = "paymentStatus=INITIATED&validationStatus=DRAFT&publicToken=null";
    const paramProcessing = "paymentStatus=PROCESSING&validationStatus=DRAFT&publicToken=null";

    Promise.all([
      axios.get(`${url}?${paramInitiated}`, {
        headers: { Authorization: `Bearer ${token}` }
      }),
      axios.get(`${url}?${paramProcessing}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
    ])
    .then(([responseInitiated, responseProcessing]) => {
        const merged = [
          ...(responseInitiated.data.data || []),
          ...(responseProcessing.data.data || [])
        ];
        merged.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
        
        transactions.value = merged;
        loader.value=true;
    }).catch((error) => {
        loader.value=true;
        if( error.response){
            console.log(error.response.data);
            if(error.response.status === 401){
              router.push('/');
            }
        }
    });

}

const showPendingTransactions = () =>{
        
    

    //conf.proxy
    axios.get(`${url}?${idType}=${transactionId}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
          transaction1s.value = response.data.data; 
               
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                 router.push('/');
              }   
              
          }
  });

}

const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;  //.data.users          
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
                //window.location.href = '/';
                //router.push('/');
              }   
              
          }
   });
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{ 
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    operatorsTemp = response.data;         
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const showScreen = (statut,msg)=>{ 
  status.value=statut;
  message.value=msg;
}

const showScreenIndividual = (statut,msg,payoutid,payoutType)=>{ 
  status.value=statut;
  message.value=msg;
  transactionId=payoutid;
  idType=(payoutType==2)?'intBulkId':'payoutId';
  transaction1s.value=[];
  if(payoutType==2){
    showPendingTransactions()
  }
  
}

const storeTransfert =()=>{
try {  
  
  axios.post(`${url}/validate`,{
    transactionId:transactionId,
    idType:idType,
    status:status.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => { 
        
        if(response.status === 201){  
          router.go();
          showToast("Transfert réussi","green");
          status.value='';
          setTimeout(() => {
            router.go();
            // router.push('/transferts'); 
            }, 4000);          
           
        }      
        
    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }    
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
            (_unref(type_of_task)!='default')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                      (_unref(current_permissions)('validate_payout_transaction'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                            type: "button",
                            style: {"background-color":"#EB9355"},
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#filterLeadModal",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (showScreen('REJECTED','Voulez-vous vraiment annuler ce transfert ?')))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('validation.cancel')) + " ", 1),
                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-close position-relative ms-5 top-2 fs-15" }, null, -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_unref(current_permissions)('validate_payout_transaction'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                        type: "button",
                        style: {"background-color":"#EB9355"},
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#filterLeadModal",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showScreen('VALIDATED','Voulez-vous vraiment confirmer ce transfert ?')))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('validation.confirm')) + " ", 1),
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    placeholder: _ctx.$t('validation.search')
                  }, null, 8, _hoisted_10), [
                    [_vModelText, _unref(searchQuery)]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('validation.code')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('validation.beneficiary')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('validation.operator')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('validation.phone')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('validation.amount')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('validation.date')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('validation.status')), 1),
                    _cache[15] || (_cache[15] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedTransactions), (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.payoutId
                    }, [
                      _createElementVNode("th", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(transaction.payoutId), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(transaction.clientId || '-'), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(transaction.operator.mnoName), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(transaction.contact), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(transaction.amount.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(formatDateFr(new Date(transaction.transactionDate))), 1),
                      _createElementVNode("td", _hoisted_28, [
                        (transaction.paymentStatus==='SUCCEEDED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('validation.success')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='FAILED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('validation.failed')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='PROCESSING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('validation.processing')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='PENDING')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('validation.pending')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='INITIATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('validation.initiated')), 1))
                          : _createCommentVNode("", true),
                        (transaction.paymentStatus==='SCHEDULED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('validation.scheduled')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _cache[18] || (_cache[18] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          (_unref(type_of_task)=='default')
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_37, [
                                _createElementVNode("li", null, [
                                  (_unref(current_permissions)('validate_payout_transaction'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#filterLeadModal1",
                                        onClick: ($event: any) => (showScreenIndividual('VALIDATED','Voulez-vous vraiment confirmer ce transfert ?',(transaction.payoutType==2)?transaction.intBulkId:transaction.payoutId,transaction.payoutType)),
                                        class: "dropdown-item d-flex align-items-center position-relative transition border-0 fw-medium text-black pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                                        type: "button"
                                      }, [
                                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.confirm')), 1)
                                      ], 8, _hoisted_38))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("li", null, [
                                  (_unref(current_permissions)('validate_payout_transaction'))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#filterLeadModal1",
                                        onClick: ($event: any) => (showScreenIndividual('REJECTED','Voulez-vous vraiment annuler ce transfert ?',(transaction.payoutType==2)?transaction.intBulkId:transaction.payoutId,transaction.payoutType)),
                                        type: "button",
                                        class: "dropdown-item d-flex align-items-center position-relative transition border-0 fw-medium text-black pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
                                      }, [
                                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-close position-relative ms-5 top-2 fs-15" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.cancel')), 1)
                                      ], 8, _hoisted_39))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (_unref(filteredTotal)>_unref(pageSize))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx.$t('validation.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(showingFrom)) + "-" + _toDisplayString(_unref(showingTo)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=_unref(pageSize))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.$t('validation.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('validation.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_47, [
                    _createElementVNode("ul", _hoisted_48, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_50, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_51))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t('validation.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              id: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              (status.value=='REJECTED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_60, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (status.value=='VALIDATED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_61, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createElementVNode("h6", _hoisted_63, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_64, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('validation.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (storeTransfert()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_67))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('validation.yes')), 1)
            ], 8, _hoisted_66)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("h1", _hoisted_73, _toDisplayString(_ctx.$t('validation.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              id: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              (status.value=='REJECTED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_76, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (status.value=='VALIDATED' && errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_77, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _createElementVNode("h6", _hoisted_79, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_80, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true),
            (transaction1s.value.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createElementVNode("table", _hoisted_82, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_83, _toDisplayString(_ctx.$t('validation.beneficiary')), 1),
                        _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.$t('validation.operator')), 1),
                        _createElementVNode("th", _hoisted_85, _toDisplayString(_ctx.$t('validation.phone')), 1),
                        _createElementVNode("th", _hoisted_86, _toDisplayString(_ctx.$t('validation.amount')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction1s.value, (transaction1) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: transaction1.payoutId
                        }, [
                          _createElementVNode("td", _hoisted_87, _toDisplayString(transaction1.clientId), 1),
                          _createElementVNode("td", _hoisted_88, _toDisplayString(transaction1.operator.mnoName), 1),
                          _createElementVNode("td", _hoisted_89, _toDisplayString(transaction1.contact), 1),
                          _createElementVNode("td", _hoisted_90, _toDisplayString(transaction1.amount.toLocaleString()), 1),
                          _createElementVNode("td", _hoisted_91, _toDisplayString(formatDateFr(new Date(transaction1.transactionDate))), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('validation.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[10] || (_cache[10] = ($event: any) => (storeTransfert()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_94))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$t('validation.yes')), 1)
            ], 8, _hoisted_93)
          ])
        ])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})